import CoreuiController from "../lib/coreui-controller"
import ChipInput from "../coreui/chip-input"

export default class CoreuiChipInputController extends CoreuiController {
  static Component = ChipInput
}
